module.exports = __webpack_public_path__ + "img/successful.73aaa3a2.png";